import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faCheckCircle, faEdit } from '@fortawesome/free-solid-svg-icons';

const Type3ContinueModalActionButton = ({ 
  formData,
  editMode,
  onClose,
  toggleEdit,
  handleSave,
  handleVerify 
}) => {
  return (
   <div className="flex justify-end gap-2 mt-1">
      <input
        type="text"
        value={formData.formNumber}
        className="hidden"
        readOnly
      />
      
      {editMode ? (
        <>

          {/* <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 text-white font-medium rounded text-xs hover:bg-blue-700 flex items-center gap-1"
          >
            <FontAwesomeIcon icon={faSave} />
            Save
          </motion.button> */}

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleVerify}
            className="px-4 py-2 bg-green-600 text-white font-medium rounded text-xs hover:bg-green-700 flex items-center gap-1"
          >
            <FontAwesomeIcon icon={faCheckCircle} />
            Verify
          </motion.button>
        </>
      ) : (
        <></>
        // <motion.button
        //   whileHover={{ scale: 1.02 }}
        //   whileTap={{ scale: 0.98 }}
        //   onClick={toggleEdit}
        //   className="px-4 py-2 bg-blue-600 text-white font-medium rounded text-xs hover:bg-blue-700 flex items-center gap-1"
        // >
        //   <FontAwesomeIcon icon={faEdit} />
        //   Edit
        // </motion.button>
      )}
      
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={onClose}
        className="px-4 py-2 bg-red-600 text-white font-medium rounded text-xs hover:bg-red-700"
      >
        Close
      </motion.button>
    </div>
  );
};

export default Type3ContinueModalActionButton;